export default "__VITE_ASSET__D6_S2O1p__"